import { render, staticRenderFns } from "./ProductCategoryCombobox.vue?vue&type=template&id=3e4db5f1&scoped=true"
import script from "./ProductCategoryCombobox.vue?vue&type=script&lang=js"
export * from "./ProductCategoryCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4db5f1",
  null
  
)

export default component.exports